namespace('IO.Views.Locations', function (exports) {
  'use strict';

  exports.New = IO.Views.Locations.Edit;
});
